/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { nombre, fecha_fin, fecha_inicio },
} = checkout;

const validations = [
  Yup.object().shape({
    [nombre.name]: Yup.string()
      .required(nombre.errorMsg)
      .max(15, nombre.invalidMsg),
    [fecha_fin.name]: Yup.date().required(fecha_fin.errorMsg),
    [fecha_inicio.name]: Yup.date().required(fecha_fin.errorMsg),
  }),
];

export default validations;
